// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsAction_container__icxQs","icon":"SettingsAction_icon__305h2","title":"SettingsAction_title__1Pixa"};